<div class="evt-option-type-ahead">
  <button *ngIf="addBtnPosition === 'top'" class="wms wms-plus btn-transparent property-action add" (click)="addEvtHandler()" [disabled]="disable" title="{{locale.LABEL_PROPERTYGROUP_ADD_NEW_EVENT_HANDLER_TITLE}}"></button>
  <div class="event-handler" *ngFor="let fn of fns;let index=index">
    <span class="info">{{locale.LABEL_PROPERTYGROUP_AND}}</span>
    <div *ngIf="fn.fnName?.length" [ngClass]="{'event-container': addBtnPosition !== 'top'}" title="{{fn.fnName}}">
<!--      TODO: add && !disable in ngif-->
      <div *ngIf="fn.fnType === 'USER_DEFINED' && !disable" class="event-name-readonly form-control">
        <a (click)="navigateToScript(fn.fnName)">{{fn.fnName}}</a>
      </div>
<!--      TODO: add ||disable in ngif below-->
      <div *ngIf="fn.fnType !== 'USER_DEFINED' || disable" class="event-name-readonly form-control" [ngClass]="{error : isExists(_fns[index])}">
        <span>{{fn.fnName}}</span>
        </div>
      </div>
    <div *ngIf="!fn.fnName?.length">

      <!--      TODO: add identifier to below input-->
      <wms-typeahead [typeaheadUid]="typeaheadUid"  propertyName="name" groupBy="category" [dropdownClass]="addBtnPosition === 'top' ? 'properties-typeahead-dropdown' : ''"
                      placeholder="{{locale.LABEL_PROPERTYGROUP_SEARCH_PLACEHOLDER}}" (onSelect)="_onChange(index,$event)"
                      [options]="getFilteredOptions(widgetEventOptions)" [disable]="disable" [showActionButtons]="false"></wms-typeahead>

    </div>
    <button *ngIf="index === 0 && addBtnPosition !== 'top'" class="wms wms-plus btn-transparent property-action add" (click)="addEvtHandler()" [disabled]="disable" title="{{locale.LABEL_PROPERTYGROUP_ADD_NEW_EVENT_HANDLER_TITLE}}"></button>
    <button class="wm-icon wms wms-edit edit" *ngIf="_fns[index]" (click)="removeEvtHandler(index, true)"
        [disabled]="disable" title="{{locale.LABEL_PROPERTYGROUP_EDIT_EVENT}}"></button>
        <button class="wms wms-clear btn-transparent property-action delete" (click)="removeEvtHandler(index)"
        [disabled]="disable" title="{{locale.LABEL_PROPERTYGROUP_REMOVE_EVENT_HANDLER}}"></button>
  </div>
</div>
